module.exports = __webpack_public_path__ + "img/bookmark-dash.9c7683f7.svg";